import domready from 'domready'
import initVimeoControllerByAttributes from './common-util/vimeo/init-vimeo-controller-by-attributes'

export default function initVimeoVideos () {
  domready(() => {
    console.log('vimeo')
    const vimeoContainerElements = document.querySelectorAll('[data-vimeo-controller-autoinit]')
    ;[].forEach.call(vimeoContainerElements, (element) => {
      console.log('vimeo', element)
      element.vimeoController = initVimeoControllerByAttributes(element)
    })
  })
}
